import { routeAdjustmentManager } from "@/setup/routes/adjustment.routes";
import { routeDelaysManager } from "@/setup/routes/delay.routes";
import { routeCobblesManager } from "@/setup/routes/mill.routes";
import { MenuOptionType } from "@dexteel/mesf-core";
import {
	AddOutlined,
	Build,
	Delete,
	EditOutlined,
	Memory,
	SwapHoriz,
} from "@mui/icons-material";
import { installData } from "../GanttChart";

function isDelay(data: any) {
	return "delayId" in data;
}

function isAdjustment(data: any) {
	return "adjustmentId" in data;
}

function isCobble(data: any) {
	return "cobbles" in data;
}

function isCarrier(data: any) {
	return "partId" in data;
}

function isEmpty(data: any) {
	return (
		"activeStand" in data &&
		"activeSection" in data &&
		"activeStandId" in data &&
		"activeSectionId" in data
	);
}

export const useGanttOptionsFunctions = ({
	setDataToInstallCarrier,
	setShowConfirmDialog,
	setIsModalOpen,
	setOpenPassChangeDialog,
}: {
	setDataToInstallCarrier: (data: installData | null) => void;
	setShowConfirmDialog: (show: boolean) => void;
	setIsModalOpen: (open: boolean) => void;
	setOpenPassChangeDialog: (open: boolean) => void;
}) => {
	const getMenuOptions = (data: any) => {
		let options: MenuOptionType[] = [];

		if (isEmpty(data)) {
			options = options.concat([
				{
					name: "New carrier",
					key: "new_carrier_instance",
					onClick: () => {
						setDataToInstallCarrier({
							clickedTime: data.clickedTime,
							activeSection: data.activeSection,
							activeSectionId: data.activeSectionId,
							activeStand: data.activeStand,
							activeStandId: data.activeStandId,
						});
						setIsModalOpen(true);
					},
					icon: <AddOutlined />,
				},
			]);
		}
		if (isCarrier(data)) {
			const isEdgerRoll =
				!data.topRollName?.includes("UR") ||
				!data.bottomRollName?.includes("UR");

			if (["I", "U", "F"].includes(data.carrierStatus) && isEdgerRoll) {
				options = options.concat({
					name: "Change Passes",
					key: "change_passes",
					onClick: () => {
						setDataToInstallCarrier({
							clickedTime: data.clickedTime,
							partId: data.partId,
							carrierInstanceId: data.carrierInstanceId,
							activeSection: data.activeSection,
							activeSectionId: data.activeSectionId,
							activeStand: data.activeStand,
							activeStandId: data.activeStandId,
						});
						setOpenPassChangeDialog(true);
					},
					icon: <SwapHoriz />,
				});
			}
			options = options.concat([
				{
					name: "Edit carrier",
					key: "edit_carrier_instance",
					onClick: () => {
						setDataToInstallCarrier({
							installedat: data.start,
							uninstalledat: data.end,
							partId: data.partId,
							carrierInstanceId: data.carrierInstanceId,
							rollsetId: data.rollsetId,
							activeSection: data.sectionName,
							activeSectionId: data.sectionId,
							activeStand: data.standName,
							activeStandId: data.standId,
						});
						setIsModalOpen(true);
					},
					icon: <EditOutlined />,
				},
				{
					name: "Delete carrier",
					key: "delete_carrier_instance",
					onClick: () => {
						setShowConfirmDialog(true);
						setDataToInstallCarrier({
							installedat: data.start,
							uninstalledat: data.end,
							partId: data.partId,
							partName: data.partName,
							carrierInstanceId: data.carrierInstanceId,
							rollsetId: data.rollsetId,
							activeSection: data.sectionName,
							activeSectionId: data.sectionId,
							activeStand: data.standName,
							activeStandId: data.standId,
						});
						setIsModalOpen(true);
					},
					icon: <Delete />,
				},
			]);
		}
		if (isDelay(data)) {
			options = options.concat([
				{
					name: "See in Manager",
					key: "see_delays_manager",
					onClick: () => {
						window.open(
							`${routeDelaysManager}/${data.shiftId}?assetId=12&delayId=${data.delayId}`,
							"_blank",
						);
					},
					icon: <Memory />,
				},
			]);
		}
		if (isAdjustment(data)) {
			options = options.concat([
				{
					name: "See in Manager",
					key: "see_adjustments_manager",
					onClick: () => {
						window.open(
							`${routeAdjustmentManager}/${data.shiftId}?adjustmentId=${data.adjustmentId}`,
							"_blank",
						);
					},
					icon: <Build />,
				},
			]);
		}
		if (isCobble(data)) {
			options = options.concat([
				{
					name: "See in Manager",
					key: "see_cobbles_manager",
					onClick: () => {
						window.open(
							`${routeCobblesManager}/${data.shiftId}?cobbleId=${data.cobbleId}`,
							"_blank",
						);
					},
					icon: <Build />,
				},
			]);
		}

		return options;
	};
	return {
		getMenuOptions,
	};
};
